import React from "react";
import PropTypes from "prop-types";
import styles from "./InfoDetailsList.module.css";

/**
 * Reusable label/value details list.
 * items: [{ label, value, fullWidth? }]
 */
const InfoDetailsList = ({
  items = [],
  emptyText = "No details available.",
}) => {
  const visibleItems = items.filter(
    (item) =>
      item &&
      item.value !== null &&
      item.value !== undefined &&
      item.value !== "",
  );

  if (!visibleItems.length) {
    return <div className={styles.empty}>{emptyText}</div>;
  }

  return (
    <dl className={styles.grid}>
      {visibleItems.map((item) => (
        <div
          key={item.label}
          className={`${styles.item} ${item.fullWidth ? styles.itemFull : ""}`}
        >
          <dt className={styles.label}>{item.label}</dt>
          <dd className={styles.value}>{item.value}</dd>
        </div>
      ))}
    </dl>
  );
};

InfoDetailsList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node,
      ]),
      fullWidth: PropTypes.bool,
    }),
  ),
  emptyText: PropTypes.string,
};

export default InfoDetailsList;
